import i18n from './locales';
import mixins from './utils/mixins';
import { default as Api } from './utils/api';
import global from './utils/global';
import cookie from './utils/cookie';
import storage from './utils/storage';
import request from './utils/request';
import tools from './utils/tools';
import async from './utils/async';
import prism from './directives/prism';
import inputLimit from './directives/input_limit';
import { default as Layout } from './components/layout';
import { default as Notice } from './components/notice';
import { default as Menu } from './components/menu';
import { default as Dropdown } from './components/dropdown';
import { default as Clock } from './components/clock';
import { default as Search } from './components/search';
import { default as Captcha } from './components/captcha';
import { default as Password } from './components/password';
import { default as Anchor } from './components/anchor';
import { default as Modal } from './components/modal';
import { default as Login } from './components/login';
import { default as Register } from './components/register';
import { default as Forget } from './components/forget';
import { default as History } from './components/history';
import { default as Code } from './components/code';
import { default as Title } from './components/title';
import { default as Quotes } from './components/quotes';
import { default as BackTop } from './components/backtop';
import { default as LanguageManagement } from './components/management/language';
import { default as MenuManagement } from './components/management/menu';
import { default as AppsManagement } from './components/management/application';
const components = [
    i18n,
    Api,
    global,
    cookie,
    storage,
    request,
    tools,
    inputLimit,
    prism,
    Layout,
    Notice,
    Menu,
    Dropdown,
    Clock,
    Search,
    Captcha,
    Password,
    Anchor,
    Modal,
    Login,
    Register,
    Forget,
    History,
    Code,
    Title,
    Quotes,
    BackTop,
    LanguageManagement,
    MenuManagement,
    AppsManagement
];
let _init = false;
const install = (app) => {
    if (!_init) {
        app.mixin(mixins);
        components.forEach((comp) => {
            app.use(comp);
        });
        _init = true;
    }
    return app;
};
export { Api, global, cookie, storage, request, tools, async, prism, Layout, Notice, Menu, Dropdown, Clock, Search, Captcha, Password, Anchor, Modal, Login, Register, Forget, History, Code, Title, Quotes, BackTop, LanguageManagement, MenuManagement, AppsManagement };
export default {
    install
};
